import React from 'react'
import styled, { keyframes } from 'styled-components'
import PropTypes from 'prop-types'

const FadeInDown = keyframes`
  0% {
    opacity: 0;
    transform: translate3d(0, -20px, 0);
  }

  100% {
    opacity: 1;
    transform: translate3d(0, 0px, 0);
  }
`
const FadeOutUp = keyframes`
  0% {
    opacity: 1;
    transform: translate3d(0, 0px, 0);
  }
  100% {
    opacity: 0;
    transform: translate3d(0, -20px, 0);
  }
`
const Container = styled.div`
  top: 123px;
  position: fixed;
  left: 0;
  right: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  background: ${(props) => (props.isError ? '#BC3C4B' : '#DFF0D8')};
  color: ${(props) => (props.isError ? 'white' : '#468847')};
  width: 100%;
  padding: 20px;
  animation:
    ${FadeInDown} 0.4s ease forwards,
    ${FadeOutUp} 0.4s ease forwards;
  animation-delay: 0s, ${(props) => props.duration + 0.4}s;
  z-index: 9999;
`
const Content = styled.div`
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
`
const Close = styled.div`
  position: absolute;
  top: 0;
  bottom: 0;
  right: 50px;
  font-weight: bold;
  cursor: pointer;
`

const SuccessNotification = ({
  animationKey,
  duration,
  onClose,
  text,
  isError = false,
}) => (
  <Container key={animationKey} duration={duration} isError={isError}>
    <Content>
      <span>{text}</span>
      <Close id="close_success_notification" onClick={onClose}>
        X
      </Close>
    </Content>
  </Container>
)

SuccessNotification.propTypes = {
  duration: PropTypes.number.isRequired,
  onClose: PropTypes.func,
  text: PropTypes.string.isRequired,
}

export default SuccessNotification
